module.exports = __webpack_public_path__ + "static/img-22-8ee110d1b411eb5732c0ce6929e5d1ac.jpeg";